import React from "react";

function ImportProgressContent({ toastId, dismiss, large, fileName, message, showLink, companyId, history }) {

    return (
      <div className={`toast-assets ${large ? "large" : ""}`}>
        <span className="toast-info">
          <span className="file-name">
            {`${fileName ?? "File"} `}
          </span>
        </span>

        <span className={`${message ? "toast-extra-info d-flex flex-col flex-wrap" : ""}`}>
          
          {message ? <p>{message}</p> : <></>}
          
          {showLink &&
            <span
              id="import-progress-link"
              onClick={() => {
                companyId && history.push(`/companies/company/${companyId}/assets/logs`);
                dismiss(toastId);
              }}
            >
              View Import Progress
            </span>
          }
        </span>
      </div>
    );
  }

  export default ImportProgressContent;